<template lang="pug">
server-data(
  ref="serverData"
  :method="fetchRequests"
  v-model="teamsInput"
  :serialize-data="serializeData"
  v-bind="extendAttrs"
  :no-init="noInit"
  v-slot="{ serverData: teams, loading, isInitialized }"
)
  text-loader.pointer-events-none.user-select-none.my-12.py-12(
    v-if="loading || !(isInitialized || noInit)"
    :is-init="false"
  )
  p.my-12(v-else-if="!teams || !(teams && teams.length)") Нет заявок
  v-sheet.redesign.transparent.redesign-scrollbar.overflow-y.pr-2.pb-2(
    v-else
    min-height="300px"
    max-height="50vh"
  )
    v-expansion-panels.d-flex.flex-column.gap-16(
      flat
      filled
      accordion
      multiple
    )
      v-expansion-panel.rounded-16.no-before.no-after.py-3.px-4.full-width.mt-0(
        v-for="(team, idx) in teams"
        :key="team.id"
        v-bind="extendAttrs['item-container']"
      )
        v-expansion-panel-header.pa-0.ma-0.align-center.gap-24.no-before
          app-avatar.rounded-12(
            :avatar="team.avatar"
            size="60"
            icon="$ipicture"
          )
          .d-flex.flex-column.gap-8
            .title-1.line-clamp-1
              span.mr-2 {{ idx + 1 }}.
              span {{ team.team_name }}
            .body-1.px-2.py-1.rounded-8.fit-content-width(
              v-if="team.nominationName"
              v-bind="extendAttrs['item-childs']"
            ) {{ team.nominationName }}

          tooltip-wrap(
            :value="!!team.comment"
            top
            activator-class="flex-grow-0"
            content-class="redesign redesignControlsBackground redesign-box-shadow rounded-8 opacity-100"
          )
            template(#reason)
              p.redesignPrimaryDarken--text.text-capitalize {{ team.comment }}
            .d-flex.align-center.gap-8.pa-2.pr-3.rounded-16.ml-auto.flex-grow-0(
              :class="team.request_status.attrs.color"
            )
              v-icon(color="redesignControlsBackground") {{ team.request_status.icon }}
              .body-1.redesignControlsBackground--text.text-nowrap {{ team.request_status.text }}
          .d-flex.gap-12.flex-grow-0(v-if="team.isEditable")
            app-button.rounded-12.px-0(
              x-small
              width="40px"
              height="40px"
              max-width="40px"
              v-bind="extendAttrs['item-childs']"
              @click.stop="$emit('edit-team', team)"
            )
              v-icon(color="redesignPrimaryDarken" size="20") $ipencil

            app-button.rounded-12.px-0(
              x-small
              width="40px"
              height="40px"
              max-width="40px"
              v-bind="extendAttrs['item-childs']"
              @click.stop="removeTeamDialog(team.id)"
            )
              v-icon(color="redesignError" size="21") $itrash

          template(#actions)
            v-icon(size="18" color="redesignBlack") $ichevron-down
        v-expansion-panel-content
          .d-flex.flex-column.text-left.gap-8.mt-4
            .title-1 {{ team.team_name }}
            .body-1.weight-500.redesignSecondary--text.mb-2 {{ team.team_description }}
            .body-1.pa-3.rounded-12.d-flex.align-center.gap-16(
              v-for="member in team.members"
              :key="member.id"
              v-bind="extendAttrs['item-childs']"
            )
              template(v-if="member.profile")
                app-avatar.rounded-circle(:avatar="member.profile.avatar")
                .body-1.weight-500 {{ member.profile.name }}
              .body-1(v-else) {{ member.username }}

</template>

<script>
import AppButton from '@/components/user-redesign/controls/AppButton.vue';
import TextLoader from '@/components/user-redesign/layout/TextLoader.vue';
import AppAvatar from '@/components/user-redesign/AppAvatar.vue';
import { deepObjectMerge } from '@/modules/UserEventLanding/functions';

export default {
  components: {
    TextLoader,
    AppButton,
    AppAvatar,
  },
  props: {
    items: {
      type: Array,
      default: null,
    },
    eventId: {
      type: Number,
      default: null,
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      noInit: false,
      serializeData: (response) => response.items,
    };
  },
  computed: {
    teamsInput: {
      get() {
        return this.items;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    extendAttrs() {
      const { $attrs } = this;
      return deepObjectMerge(
        {
          'item-container': {
            class: 'redesignControlsBackground',
          },
          'item-childs': {
            class: 'redesignControlsBackgroundAlternative',
          },
        },
        $attrs,
      );
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.noInit = !!this.items;
    },
    async fetchRequests() {
      const params = {
        sort: '-id',
        'search[owner_id]': this.$user.data.id,
        'per-page': -1,
        ...this.filters,
        expand: 'event,nomination,owner,members,comment,team,avatar',
      };
      if (this.eventId) {
        params['search[event_id]'] = this.eventId;
      }
      const { items, error, response } = await this.$models.team.objects.requests.index({ params }, true);
      return { items, ...response, ...error };
    },
    removeTeamDialog(id) {
      this.$dialogs.confirm({
        attrs: {
          method: () => this.removeTeam(id),
          message: 'Вы действительно хотите отменить заявку с этой командой?',
          closeBtnAttrs: {
            'btn-text': 'Оставить',
          },
          confirmBtnAttrs: {
            'btn-text': 'Отменить',
          },
        },
      });
    },
    async removeTeam(id) {
      const { response, error } = await this.$models.team.objects.requests.delete({ args: [id] });
      if (error) {
        return { error };
      }

      this.refresh();

      return { response };
    },

    refresh() {
      const { init } = this?.$refs?.serverData || {};
      if (init) init();
      this.$emit('refresh');
    },
  },
};
</script>
